import { render, staticRenderFns } from "./radio-control.vue?vue&type=template&id=19c894b5&"
import script from "./radio-control.vue?vue&type=script&lang=js&"
export * from "./radio-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports